import * as React from 'react'
import { RegistrationPanelProps } from './types'
import { RegistrationProvider } from './context/registration'
import { NewStyled } from './styled'
import { PasswordResetView } from './views/PasswordReset'
import { Route } from './components'
import { DownloadsView, LoginView } from './views'
import { sbEditable } from '@storyblok/storyblok-editable'
import { FreeTrial } from './components/FreeTrial'
import { SignupProvider } from './context/signup'
import { navigate } from 'gatsby';

export const RegistrationPanel = ({ blok }: RegistrationPanelProps) => {
  React.useEffect(() => {
    navigate('/contact');
  }, []);

  return (
    <RegistrationProvider blok={blok} {...sbEditable(blok)}>
      <NewStyled.Wrapper className={blok.theme ? `theme-${blok.theme}` : `theme-bluetiful`}>
        <NewStyled.Card>
          <SignupProvider>
            <Route path="/" component={<FreeTrial />} />
            <Route path="/downloads" component={<DownloadsView />} />
            <Route path="/login" component={<LoginView />} />
            <Route path="/password-reset" component={<PasswordResetView />} />
          </SignupProvider>
        </NewStyled.Card>
      </NewStyled.Wrapper>
    </RegistrationProvider>
  )
}
